import '../vendor';

import '../general/ofi';
import '../general/search';
import '../general/hamburger';
import '../general/menu';
import '../general/anchor';
import '../general/warning';
import '../general/up';

import '../pages/main/museums-slider';
import '../pages/main/events-slider';
import '../pages/main/partners-slider';
import '../pages/main/info-slider';
import '../pages/main/museums-info';
import '../pages/main/subscription';

import '../visually-impaired/open';
import '../visually-impaired/click';
import '../visually-impaired/size';
import '../visually-impaired/color';
import '../visually-impaired/length';
import '../visually-impaired/image';


// WEBPACK FOOTER //
// ./src/js/pages/main.js